export const MSG_EXPIRED_SESSION = 'Sua sessão expirou, faça o login novamente.'
export const MSG_NOT_DELIVERY_AREA = 'Atualmente, não realizamos entregas para esta localização.'
export const MSG_DELIVERY_UNAVAILABLE = 'Entrega indisponível. Por favor, tente novamente mais tarde.'